<template>
<section class="blockquote px-4">
    <div class="max-w-2xl mx-auto">
        
        <SmoothLoader tag="blockquote" class="bg-primary-500 p-8 vt:p-12 rounded relative">

            <i class="fa-solid fa-quote-left absolute text-primary-300"></i>

            <div class="fake-border absolute pointer-events-none rounded border-white border-solid border" aria-hidden="true"></div>
            <p v-html="'&ldquo;' + quote + '&rdquo;'" class="text-3xl text-white"></p>
            <cite class="text-right flex justify-end font-bold block w-full not-italic">
                <div class="w-full vt:w-2/3 mt-6">
                    <span class="author text-white font-headline text-2xl block mb-2" v-html="'&mdash; ' + person_name"></span>
                    <span class="title block uppercase font-headline text-white text-base" v-if="person_title" v-html="person_title"></span>
                </div>
            </cite>
        </SmoothLoader>
    </div>
</section>
</template>

<script>

export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>